import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

import { RtComponentSize } from '../../props/component-size';
import {
  RtAddNewButtonVariant,
  RtButtonColorContextVariant,
  RtButtonVariant,
  RtIconButtonVariant,
  RtInfoboxButtonVariant,
  RtPlanButtonVariant,
} from './button.types';

@Directive({
  selector: 'rt-button-base',
  host: {
    '[class]': '"rt-button " + size + " " + variant',
    '[class.disabled]': 'disabled === true',
    '(click)': 'onClick($event)',
  },
})
export abstract class BaseButtonDirective {
  @Input() public size: Extract<RtComponentSize, 'small' | 'medium' | 'small-x'> = 'medium';
  @Input() public variant:
    | RtButtonVariant
    | RtPlanButtonVariant
    | RtIconButtonVariant
    | RtAddNewButtonVariant
    | RtInfoboxButtonVariant
    | RtButtonColorContextVariant;
  @Input() public disabled: boolean = false;

  constructor(public renderer: Renderer2, public elRef: ElementRef) {}

  public onClick(event: Event) {
    if (!this.disabled) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }

  public addClass(names: string[]) {
    for (const name of names) {
      this.renderer.addClass(this.elRef.nativeElement, name);
    }
  }

  public removeClass(names: string[]) {
    for (const name of names) {
      this.renderer.removeClass(this.elRef.nativeElement, name);
    }
  }
}
